import { render, staticRenderFns } from "./FabPreview.vue?vue&type=template&id=6f1026a2&scoped=true"
import script from "./FabPreview.vue?vue&type=script&lang=js"
export * from "./FabPreview.vue?vue&type=script&lang=js"
import style0 from "./FabPreview.vue?vue&type=style&index=0&id=6f1026a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1026a2",
  null
  
)

export default component.exports